import React from 'react';
import { clsx } from 'clsx';
import styles from './cloudinary-image.module.scss';

type CloudinaryImageComponentProps = CloudinaryImageFragment & {
  className?: string;
};

export const CloudinaryImage: React.FC<CloudinaryImageComponentProps> = ({
  publicId,
  alt,
  caption,
  defaultImageUrls,
  sources,
  className
}) =>
  publicId && sources ? (
    <div className={clsx(className, styles.imageContainer)}>
      <picture className={styles.picture}>
        {sources.map(source => (
          <source
            key={source.srcSet}
            srcSet={source.srcSet}
            media={source.media}
            sizes={source.sizes}
          />
        ))}
        <img className={styles.image} alt={alt} title={caption} data-src={defaultImageUrls} />
      </picture>
    </div>
  ) : null;
